import React from "react";

const SpamError = () => (
  <div className="spamError">Please select at least one item</div>
);

export default SpamError;
